"use client";

import { useUTM } from "@/hooks/use-utm";

/**
 * Component to track UTM parameters on page load
 * Should be placed in the root layout
 */
export const UTMTracker = () => {
  useUTM();
  return null;
};